import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { SLUG_VIEW, VIEW_GRID } from '../../const';
import { filter } from './filter';

export const prepare = (data) => {
  const {
    hasActive,
    filters,
    filterOrder,
    filterActivity,
    sortedValues,
    amount,
    prods,
    title,
    pagination,
    nextPage,
  } = data;
  const [inStock, onSale, newProds, priceItem, brand, ...rest] = filters;
  const { active, enabled, from, to, min, max } = priceItem.items[0];
  const price = { active, enabled, from, to, min, max };

  const filterData = {
    inStock,
    onSale,
    newProds,
    price,
    brand,
    filters: rest,
    filterOrder,
    filterActivity,
    sortedValues,
    hasActive,
    amount,
  };

  return {
    filterData,
    amount,
    prods,
    pagination,
    nextPage,
    title,
  };
};

let prevController = null;

export const load = createAsyncThunk('data/load', async (payload, api) => {
  const { addr } = api.getState().url;

  if (prevController) {
    prevController.abort();
  }
  const controller = new AbortController();
  const { signal } = controller;
  prevController = controller;

  let resp;
  try {
    resp = await fetch(addr, { signal });
  } catch (err) {
    throw err;
  } finally {
    prevController = null;
  }

  if (!resp.ok) {
    const err = `request ${addr} failed, response status: ${resp.status}`;
    throw new Error(err);
  }
  const newData = await resp.json();

  const { filterData, amount, prods, pagination, nextPage, title } =
    prepare(newData);

  api.dispatch(filter.actions.update(filterData));

  return {
    amount,
    prods,
    pagination,
    nextPage,
    title,
  };
});

export const append = createAsyncThunk('data/append', async (payload, api) => {
  const { addr } = api.getState().url;
  const resp = await fetch(addr);

  if (!resp.ok) {
    const err = `request ${addr} failed, response status: ${resp.status}`;
    throw new Error(err);
  }
  const newData = await resp.json();

  const { prods, pagination, nextPage } = newData;
  return {
    prods,
    pagination,
    nextPage,
  };
});

export const catalog = createSlice({
  name: 'catalog',
  initialState: {
    loading: false,
    prods: [],
    title: '',
    pagination: null,
    view: 'grid',
    filterVisible: false,
    nextPage: -1,
    amount: null,
  },

  reducers: {
    init: (state, { payload }) => {
      const { search } = payload;

      state.view = VIEW_GRID;
      if (search.length > 0) {
        const view = search.find(({ slug }) => slug === SLUG_VIEW);
        if (view !== undefined) {
          state.view = view.values[0];
        }
      }

      const newData = window.pageData;
      const { amount, prods, pagination, nextPage, title } = prepare(newData);

      state.prods = prods;
      state.pagination = pagination;
      state.loading = false;
      state.nextPage = nextPage;
      state.title = title;
      state.amount = amount;

      return state;
    },

    updateView: (state, { payload }) => {
      const { view } = payload;
      state.view = view;
      return state;
    },

    showFilter: (state) => {
      state.filterVisible = true;
      return state;
    },

    hideFilter: (state) => {
      state.filterVisible = false;
      return state;
    },
  },

  extraReducers: {
    [load.pending]: (state, _) => {
      state.loading = true;
    },

    [load.fulfilled]: (state, { payload }) => {
      const { prods, pagination, nextPage, title, amount } = payload;

      state.prods = prods;
      state.pagination = pagination;
      state.loading = false;
      state.nextPage = nextPage;
      state.title = title;
      state.amount = amount;
    },

    [load.rejected]: (state, { error }) => {
      state.loading = false;
      console.log('an error occured on fetch filters: %o', error);
    },

    [append.pending]: (state, _) => {
      state.loading = true;
    },

    [append.fulfilled]: (state, { payload }) => {
      const { prods, pagination, nextPage } = payload;

      const newProds = [...state.prods, ...prods];
      state.prods = newProds;

      state.pagination = pagination;
      state.nextPage = nextPage;
      state.loading = false;
    },

    [append.rejected]: (state, { error }) => {
      state.loading = false;
      console.log('an error occured on fetch filters: %o', error);
    },
  },
});

export default catalog.reducer;
